import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import Link from "@mui/material/Link";
//
import { useSearchParams } from "react-router-dom";
import { Link as RLink } from "react-router-dom";
//
import { SerializedError } from "../../util/types";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useByFilterQuery } from "../../api/file";
import { FileMetadataItem, partitionByImages } from "./fileSlice";
import { newFilter } from "../filter/filterSlice";
import MyImageList from "./ImageList";
import FileMetadataList from "./FileMetadataList";

export default function Layout() {
    const [searchParams] = useSearchParams();
    let { id } = useParams();
    const pageId = searchParams.get("page_id");
    const contactId = searchParams.get("contact_id");
    const text = searchParams.get("text");
    const idv = id ? id : null;
    const idStr = id ? id : "";
    let f = newFilter();
    f.page_id = pageId;
    f.contact_id = contactId;
    let content: React.ReactNode;
    //c onsole.log("2024101608254", idStr);
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useByFilterQuery(f, { refetchOnMountOrArgChange: true });
    if (isLoading) {
        content = <div></div>;
    } else if (isFetching) {
        content = <div>fetching </div>;
    } else if (isSuccess) {
        const [images, nonImages] = partitionByImages(data.files);
        console.log("THIS IS THE FILES DATA: ", nonImages, images);
        content = (
            <>
                {pageId && (
                    <Link component={RLink} to={"/page/view/" + pageId}>
                        Page View
                    </Link>
                )}
                {contactId && (
                    <Link component={RLink} to={"/contact/view/" + contactId}>
                        Contact View
                    </Link>
                )}
                {/*<Box
                    sx={{ backgroundColor: "red", width: 500, height: 450 }}
                ></Box>*/}
                <FileMetadataList data={nonImages} />
                <MyImageList data={images} />
            </>
        );
    } else if (isError) {
        content = <FileApiError error={error} />;
    }
    return <Box>{content}</Box>;
}

interface FilesListProps {
    data: { [key: string]: FileMetadataItem };
}

function FileApiError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <>Error</>;
}
